import HomeLanding from '../Components/HomeLanding';

//page containing the HomeLanding component
function Home(){

    return (
        <div className='page-container'>
            <HomeLanding />
        </div>
    )
}

export default Home;